var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappFloat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4633_2356)",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 38,
    r: 32,
    fill: "#1ACC60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3686 22.9306C45.0833 23.1131 48.5447 24.645 51.1884 27.2905C54.0085 30.1123 55.5607 33.8631 55.5591 37.852C55.5558 46.0835 48.8547 52.781 40.6227 52.781C37.5271 52.781 35.0671 51.8299 33.4787 50.9639L25.5606 53.0399L27.6797 45.3037C26.3726 43.0397 25.6848 40.4715 25.6858 37.8402C25.6892 29.6089 32.3897 22.9121 40.6225 22.9121L41.3686 22.9306ZM33.8455 48.2612L34.2989 48.5301C36.205 49.6607 38.3899 50.2589 40.6176 50.2597H40.6226C47.4653 50.2597 53.0345 44.6932 53.0372 37.8512C53.0385 34.5357 51.7484 31.4181 49.4045 29.0727C47.0605 26.7271 43.9435 25.4347 40.6276 25.4336C33.7797 25.4336 28.2105 30.9996 28.2077 37.8411C28.2068 40.1857 28.8631 42.4691 30.1058 44.4447L30.401 44.9142L29.1469 49.4931L33.8455 48.2612ZM48.1476 41.4021C48.0543 41.2464 47.8055 41.1531 47.4323 40.9664C47.0591 40.7797 45.2242 39.8773 44.8821 39.7527C44.54 39.6283 44.2912 39.5662 44.0424 39.9395C43.7937 40.3129 43.0784 41.1531 42.8606 41.4021C42.643 41.6511 42.4253 41.6822 42.0521 41.4955C41.6789 41.3088 40.4763 40.9148 39.0508 39.644C37.9413 38.6548 37.1923 37.4333 36.9746 37.0599C36.7569 36.6865 36.9514 36.4845 37.1382 36.2986C37.3061 36.1314 37.5115 35.8629 37.6981 35.6451C37.8847 35.4273 37.9468 35.2716 38.0713 35.0227C38.1957 34.7737 38.1335 34.556 38.0402 34.3693C37.9468 34.1825 37.2005 32.3463 36.8895 31.5994C36.5865 30.8721 36.2788 30.9706 36.0497 30.9591C35.8323 30.9483 35.5833 30.9459 35.3345 30.9459C35.0857 30.9459 34.6813 31.0392 34.3392 31.4128C33.9971 31.7861 33.033 32.6887 33.033 34.5247C33.033 36.3609 34.3704 38.1345 34.557 38.3835C34.7436 38.6326 37.1886 42.4002 40.9325 44.0161C41.8229 44.4005 42.5181 44.63 43.0601 44.8019C43.9542 45.0858 44.7677 45.0458 45.4108 44.9497C46.1279 44.8426 47.6189 44.0473 47.9299 43.1761C48.2409 42.3045 48.2409 41.5577 48.1476 41.4021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4633_2356",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4633_2356"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4633_2356",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappFloat);
export default __webpack_public_path__ + "static/media/whatsapp_float.baedab9a.svg";
export { ForwardRef as ReactComponent };